import { apiCall } from './gqlClient';

const CIRCUITS_QUERY = `
  query circuits($providerId: Float) {
    circuits(providerId: $providerId)
    {
      id
			title
			description
			isPublic
			providerId
			dateCreated
			archive
			circuitType
			activityType
			targetMuscles
			executionMode
			circuitModeAmount
			circuitRestTime
			imageId
			imageUrl
      ...fragments
    }
  }`;

export const circuitsApiCall = async ({providerId}, fragments = null) => apiCall({ query: CIRCUITS_QUERY, variables: {providerId}, fragments });

const CIRCUIT_QUERY = `
  query circuit($id: String!) {
    circuit(id: $id)
    {
      id
			title
			description
			isPublic
			providerId
			dateCreated
			archive
			circuitType
			activityType
			targetMuscles
			executionMode
			circuitModeAmount
			circuitRestTime
			imageId
			imageUrl
      ...fragments
    }
  }`;

export const circuitApiCall = async ({id}, fragments = null) => apiCall({ query: CIRCUIT_QUERY, variables: {id}, fragments });

const CREATECIRCUITDEFINITION_QUERY = `
  mutation createCircuitDefinition($input: CircuitDefinitionInput!) {
    createCircuitDefinition(input: $input)
    {
      id
			title
			description
			isPublic
			providerId
			dateCreated
			archive
			circuitType
			activityType
			targetMuscles
			executionMode
			circuitModeAmount
			circuitRestTime
			imageId
			imageUrl
      ...fragments
    }
  }`;

export const createCircuitDefinitionApiCall = async ({input}, fragments = null) => apiCall({ query: CREATECIRCUITDEFINITION_QUERY, variables: {input}, fragments });

const UPDATECIRCUITDEFINITION_QUERY = `
  mutation updateCircuitDefinition($id: String!, $input: CircuitDefinitionInput!) {
    updateCircuitDefinition(id: $id, input: $input)
    {
      id
			title
			description
			isPublic
			providerId
			dateCreated
			archive
			circuitType
			activityType
			targetMuscles
			executionMode
			circuitModeAmount
			circuitRestTime
			imageId
			imageUrl
      ...fragments
    }
  }`;

export const updateCircuitDefinitionApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATECIRCUITDEFINITION_QUERY, variables: {id, input}, fragments });

const DELETECIRCUITDEFINITION_QUERY = `
  mutation deleteCircuitDefinition($id: String!) {
    deleteCircuitDefinition(id: $id)
    {
      id
			title
			description
			isPublic
			providerId
			dateCreated
			archive
			circuitType
			activityType
			targetMuscles
			executionMode
			circuitModeAmount
			circuitRestTime
			imageId
			imageUrl
      ...fragments
    }
  }`;

export const deleteCircuitDefinitionApiCall = async ({id}, fragments = null) => apiCall({ query: DELETECIRCUITDEFINITION_QUERY, variables: {id}, fragments });
